import { render } from "./TranslatePriceTierFormPage.vue?vue&type=template&id=b5c5a336&ts=true"
import script from "./TranslatePriceTierFormPage.vue?vue&type=script&lang=ts"
export * from "./TranslatePriceTierFormPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__